module.exports = __webpack_public_path__ + "img/hc_pro_night_4.af662ee4.jpg";